import React, { useState, useEffect } from "react"
import MetaTags from "react-meta-tags"
import {
  Col,
  Container,
  Row,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Card,
  CardBody,
  CardTitle,
} from "reactstrap"
import { Link } from "react-router-dom"
import LineAreaChart from "../../AllCharts/chartist/linechart"
import "chartist/dist/scss/chartist.scss"
import "../../assets/scss/chartist.scss"
import HomeCardContainer from "containers/HomeCardContainer"
// import TableList from "./TableList"

import Line from "../../components/charts/linechart"
import Doughnut from "../../components/charts/doughnutchart"

import API from "../../api/api"
const Dashboard = () => {
  const [menu, setMenu] = useState(false)
  const [jobsCount, setJobsCount] = useState([])
  const [doughnutTitles, setDoughnutTitles] = useState([])
  const [doughnutValues, setDoughnutValues] = useState([])
  const toggle = () => {
    setMenu(!menu)
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>OneP</title>
        </MetaTags>
        <Container fluid>
          <div className="page-title-box">
            <Row className="align-items-center">
              <Col md={8}>
                <h6 className="page-title">Dashboard</h6>
                <ol className="breadcrumb m-0">
                  <li className="breadcrumb-item active">
                    Welcome to Dashboard
                  </li>
                </ol>
              </Col>
              <HomeCardContainer />
            </Row>
          </div>
        </Container>
        <Row>
          <Col lg={6}>
            <Card>
              <CardBody>
                <h4 className="mt-0 header-title mb-4">Number of Users</h4>
                <div id="line-chart" className="e-chart">
                  <Line chartType="users" />
                </div>
              </CardBody>
            </Card>
          </Col>
          <Col lg={6}>
            <Card>
              <CardBody>
                <h4 className="mt-0 header-title mb-4">Number of Partners</h4>
                <div id="line-chart" className="e-chart">
                  <Line chartType="partners" />
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col lg="6">
            <Card>
              <CardBody>
                <h4 className="mt-0 header-title mb-4">Number of Orders</h4>
                <div id="line-chart" className="e-chart">
                  <Line chartType="orders" />
                </div>
              </CardBody>
            </Card>
          </Col>
          <Col lg={6}>
            <Card>
              <CardBody>
                <h4 className="mt-0 header-title mb-4">
                   Services
                </h4>
                <div id="doughnut-chart" className="e-chart">
                  <Doughnut
                    doughnutTitles={doughnutTitles}
                    doughnutValues={doughnutValues}
                  />
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </React.Fragment>
  )
}

export default Dashboard
